/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { DraggableHeader } from "src/components/Login/Styles";
import { CSSBall } from "src/components/UI/Loading/Spinners/SpinnerBall/CSSBall";

interface Props {
  progress: number;
}
export function Update({ progress }: Props) {
  return (
    <Updater>
      <DraggableHeader />
      <SpinnerWrapper>
        <CSSBall />
      </SpinnerWrapper>
      <UpdaterText>
        Updating Vienna Hypertext
        {/* only render progress bar if progress is >0 to prevent perma-load at 0% if the user
            already has the update downloaded but not installed (would happen if user pressed "Update",
            quit the app, then reopened and pressed update again - would say "Updating Vienna Hypertext 0%""
            while waiting for user to confirm "Install and restart")
            Ask pam if confused */}
        {progress > 0 && (
          <>
            <ProgressBar progress={progress} />
            <UpdaterPercent>{Math.round(progress)}%</UpdaterPercent>
          </>
        )}
      </UpdaterText>
    </Updater>
  );
}

// //////////////////////////////// //
// ELECTRON ONLY APP UPDATE SECTION //
// //////////////////////////////// //
const Updater = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;
`;

const SpinnerWrapper = styled.div`
  position: relative;
  height: 50px;
  width: 50px;
  margin-bottom: 10px;
`;

const UpdaterText = styled.div`
  font-family: "IBM Plex Mono";
  color: #c4c4c4;
  font-size: 20px;
  font-weight: 600;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

interface Progressable {
  progress: number;
}

const ProgressBar = styled.div<Progressable>`
  margin: 14px 0 4px 0;
  height: 6px;
  border-radius: 3px;
  background: #c4c4c4;
  width: ${({ progress }) => progress}%;
`;

const UpdaterPercent = styled.div`
  font-family: "IBM Plex Mono";
  color: #c4c4c4;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
`;
